import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '@services/auth-guard.service';

import { ROUTES_MAP } from './config/routes-config';

const routes: Routes = [
  {
    path: ROUTES_MAP.profile,
    loadChildren: () =>
      import('./features/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTES_MAP.resetPassword + '/:resetPasswordKey',
    loadChildren: () =>
      import('./features/change-password/change-password.module').then(
        m => m.ChangePasswordModule,
      ),
  },
  {
    path: ROUTES_MAP.login,
    loadChildren: () =>
      import('./features/login/login.module').then(m => m.LoginModule),
  },
  {
    path: '**',
    redirectTo: ROUTES_MAP.login,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
